import { render, staticRenderFns } from "./ResizeDot.vue?vue&type=template&id=60247870&scoped=true&"
import script from "./ResizeDot.vue?vue&type=script&lang=js&"
export * from "./ResizeDot.vue?vue&type=script&lang=js&"
import style0 from "./ResizeDot.vue?vue&type=style&index=0&id=60247870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60247870",
  null
  
)

export default component.exports